export default {
	sizeList: [
		{
			title: '衣服尺寸',
			list: [
				'6XS',
				'5XS',
				'4XS',
				'3XS',
				'XXS',
				'XS',
				'S',
				'M',
				'L',
				'XL',
				'XXL',
				'3XL',
				'4XL',
				'5XL',
				'6XL',
				'7XL',
				'8XL',
				'9XL',
			],
		},
		{
			title: '鞋码尺寸',
			list: ['35', '35.5', '36', '36.5', '37', '37.5', '38', '38.5', '39', '39.5', '40', '40.5', '41', '41.5', '42', '42.5', '43', '43.5', '44', '44.5', '45', '46', '47', '48', '49', '50'],
		},
		{
			title: '罩杯',
			list: [
				'A',
				'AA',
				'B',
				'C',
				'D',
				'DD',
				'DDD',
				'E',
				'EE',
				'F',
				'FF',
				'G',
				'GG',
				'H',
				'J',
				// "均码",
			],
		},
	],
}
